<style lang="sass" scoped>
  .split
    background: #fff

  .left
    float: left
    width: 55%

  .right
    float: right
    width: 45%

    ::v-deep .CodeMirror
      border: 1px solid #eee !important
      min-height: 750px !important
</style>

<template>
  <div class="split">
    <div class="left">
      <Tinymce
        :config="tinymce.options"
        v-model="content"
        variables="variables"
      />
    </div>
    <div class="right">
      <Codemirror
        ref="htmlcode"
        v-model="content"
        :options="codemirror.options"
      />
    </div>
  </div>
</template>

<script>
import { codemirror as Codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';

import 'codemirror/mode/vue/vue.js';

// active-line.js
import 'codemirror/addon/selection/active-line.js';
// styleSelectedText
import 'codemirror/addon/selection/mark-selection.js';
import 'codemirror/addon/search/searchcursor.js';
// highlightSelectionMatches
import 'codemirror/addon/scroll/annotatescrollbar.js';
import 'codemirror/addon/search/matchesonscrollbar.js';

import 'codemirror/addon/search/match-highlighter.js';
// keyMap
import 'codemirror/mode/clike/clike.js';
import 'codemirror/addon/edit/matchbrackets.js';
import 'codemirror/addon/comment/comment.js';
import 'codemirror/addon/dialog/dialog.js';
import 'codemirror/addon/dialog/dialog.css';

import 'codemirror/addon/search/search.js';
import 'codemirror/keymap/sublime.js';
// foldGutter
import 'codemirror/addon/fold/foldgutter.css';
import 'codemirror/addon/fold/brace-fold.js';
import 'codemirror/addon/fold/comment-fold.js';
import 'codemirror/addon/fold/foldcode.js';
import 'codemirror/addon/fold/foldgutter.js';
import 'codemirror/addon/fold/indent-fold.js';
import 'codemirror/addon/fold/markdown-fold.js';
import 'codemirror/addon/fold/xml-fold.js';

export default {
  props: ['mail', 'user'],

  components: {
    Codemirror,
  },

  data () {
    return {
      content: '',
      isDirty: false,
      tinymce: {
        updating: false,
        options: {
          height: 674,
          menubar: false,
          convert_urls: false,
          relative_urls: false,
          plugins: 'paste,legacyoutput,variables,table,media,image,textcolor,link,wordcount,code,fullpage,preview',
          paste_as_text: true,
          toolbar1: 'fontselect fontsizeselect forecolor | bold italic strikethrough | alignleft aligncenter alignright | table link image | preview variables',
          setup: (editor) => {
            editor.on('change keyup', () => {
              this.isDirty = true;
            })
          }
        },
      },
      codemirror: {
        updating: false,
        options: {
          tabSize: 4,
          foldGutter: true,
          styleActiveLine: true,
          lineNumbers: true,
          line: true,
          lineWrapping: true,
          keyMap: 'sublime',
          mode: 'text/x-vue',
        },
      },
    };
  },

  watch: {
    content (content) {
      this.isDirty = this.mail.html !== content;
    },
  },

  created () {
    if (this.mail.html) {
      this.content = this.mail.html;
    }

    const beforeunload = (event) => {
      if (this.isDirty) {
        const message = 'Seu conteúdo não está salvo. Deseja realmente sair do editor?';
        event.returnValue = message;
        return message;
      }
    };

    window.onbeforeunload = beforeunload;
  },

  beforeDestroy() {
    window.removeEventListener('beforeunload', this.beforeunload);
  },

  mounted () {
    Bus.$on('saveEditorContent', () => this.save());
  },

  methods: {
    save () {
      this.$http.put(`/mail/${this.mail.id}`, { html: this.content })
        .then(({ data }) => {
          this.isDirty = false;

          Alert.success(this.__('Conteúdo salvo!'));

          Bus.$emit('mailContentSaved');
        })
        .catch((error) => console.warn(error));
    },
  },
};
</script>
